import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import UserAgentMixin from '../helpers/mixins/UserAgentMixin';
import ViewportSizeMixin from '../helpers/mixins/ViewportSizeMixin';
import { S3_ASSETS_BUCKET_URL } from '../helpers/constants/LandingPage';
let LandingHeroBanner = class LandingHeroBanner extends Mixins(UserAgentMixin, ViewportSizeMixin) {
    get landingHeroBanner() {
        return `${S3_ASSETS_BUCKET_URL}/landing-hero-banner.png`;
    }
};
LandingHeroBanner = __decorate([
    Component
], LandingHeroBanner);
export default LandingHeroBanner;
